import React, { useState } from "react";
import "../Styles/signUp.css";
import logo from "../asset/Image/greyLogo.png";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logoBlack from "../asset/Image/logo1.png";
import api from "../util/axios";

const NewPass = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [sign, setSign] = useState({
    password: "",
    confirmPassword: "",
  });

  const handleChange = ({ target: { name, value } }: any) => {
    setSign({ ...sign, [name]: value });
  };

  const handleSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault();

    api
      .post(
        "/auth/password/reset/business",
        {
          password: sign.password,
          confirmPassword: sign.confirmPassword,
        }
      )
      .then((res) => {
        console.log(res);
        toast.success(res.data.message);
        setLoading(false);
        navigate("/");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setLoading(false);
      });
  };

  return (
    <div className="auth">
      <ToastContainer />
      <div className="left">
        <div>
          <img src={logo} alt="" />

          <div className="leftCon">
            <h2>Reset Password</h2>
            <p>Enter your preferred new password</p>
            <form onSubmit={handleSubmit}>
              <div className="input">
                <label>Password</label>
                <input
                  type="email"
                  placeholder="********"
                  name="email"
                  value={sign.password}
                  onChange={handleChange}
                />
              </div>
              <div className="input">
                <label>Confirm Password</label>
                <input
                  type="email"
                  placeholder="********"
                  name="email"
                  value={sign.confirmPassword}
                  onChange={handleChange}
                />
              </div>

              <button type="submit">
                {loading ? (
                  <CircularProgress
                    style={{ color: "#fff", width: "25px", height: "25px" }}
                  />
                ) : (
                  "Login"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="right">
        <div className="rightCon">
          <h4>Oneflare Business Suite</h4>

          <h2>
            <h2>
              You don't <span>Remember</span> ? Don’t worry we got you{" "}
              <span>covered</span>{" "}
            </h2>
          </h2>
        </div>

        <img src={logoBlack} alt="" className="logoBottom" />
      </div>
    </div>
  );
};

export default NewPass;
